export default "__VITE_ASSET__DzjekQcO__"